import { ELEMENT_MODULE_LOAD_CALLBACKS, ELEMENT_MODULE_LOAD_CALLBACKS_AS_ROUTES } from './element-registry';
var ɵ0 = ELEMENT_MODULE_LOAD_CALLBACKS, ɵ1 = ELEMENT_MODULE_LOAD_CALLBACKS_AS_ROUTES;
var CustomElementsModule = /** @class */ (function () {
    function CustomElementsModule() {
    }
    return CustomElementsModule;
}());
export { CustomElementsModule };
export { ɵ0, ɵ1 };
